import React from "react";
import { Outlet } from "react-router-dom";

function UserCustomDashboard() {
  return <Outlet />;
}

export default UserCustomDashboard;
